import { Grid } from '@mui/material'
import { styled } from '@mui/system'
import Link from '../../molecules/link'

const shouldForwardProp = (prop) => !['hasImages'].includes(prop)

const BackButton = styled(Link)`
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	line-height: 1;
	padding: ${({ theme }) => theme.spacing(3)};
	> .MuiSvgIcon-root {
		margin-right: ${({ theme }) => theme.spacing(1)};
	}
	${({ theme }) => theme.breakpoints.up('lg')} {
		margin-top: ${({ theme }) => theme.spacing(-1)};
		padding: 0;
	}
`

const Content = styled(Grid)`
	padding: ${({ theme }) => theme.spacing(4, 3, 3)};
`

const InnerContent = styled(Grid, { shouldForwardProp })`
	${({ theme }) => theme.breakpoints.up('lg')} {
		${({ hasImages }) =>
			hasImages &&
			`
		max-width: 370px;
		margin-left: auto;
		margin-right: auto;
		`}
	}
`

export { BackButton, Content, InnerContent }
